import { render, staticRenderFns } from "./WishlistNavComponent.vue?vue&type=template&id=0dea8478"
import script from "./WishlistNavComponent.vue?vue&type=script&lang=js"
export * from "./WishlistNavComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports